"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ape2x_png_1 = __importDefault(require("../../static/assets/ape2x.png"));
const avax2x_png_1 = __importDefault(require("../../static/assets/avax2x.png"));
const band2x_png_1 = __importDefault(require("../../static/assets/band2x.png"));
const bch2x_png_1 = __importDefault(require("../../static/assets/bch2x.png"));
const bnb2x_png_1 = __importDefault(require("../../static/assets/bnb2x.png"));
const btc2x_png_1 = __importDefault(require("../../static/assets/btc2x.png"));
const comp2x_png_1 = __importDefault(require("../../static/assets/comp2x.png"));
const crv2x_png_1 = __importDefault(require("../../static/assets/crv2x.png"));
const dai2x_png_1 = __importDefault(require("../../static/assets/dai2x.png"));
const dash2x_png_1 = __importDefault(require("../../static/assets/dash2x.png"));
const doge2x_png_1 = __importDefault(require("../../static/assets/doge2x.png"));
const eth2x_png_1 = __importDefault(require("../../static/assets/eth2x.png"));
const erc2x_png_1 = __importDefault(require("../../static/assets/erc2x.png"));
const flex2x_png_1 = __importDefault(require("../../static/assets/flex2x.png"));
const flexusd2x_png_1 = __importDefault(require("../../static/assets/flexusd2x.png"));
const floki2x_png_1 = __importDefault(require("../../static/assets/floki2x.png"));
const ftt2x_png_1 = __importDefault(require("../../static/assets/ftt2x.png"));
const goc2x_png_1 = __importDefault(require("../../static/assets/goc2x.png"));
const hapi2x_png_1 = __importDefault(require("../../static/assets/hapi2x.png"));
const lbtc2x_png_1 = __importDefault(require("../../static/assets/lbtc2x.png"));
const ltc2x_png_1 = __importDefault(require("../../static/assets/ltc2x.png"));
const mana2x_png_1 = __importDefault(require("../../static/assets/mana2x.png"));
const matic2x_png_1 = __importDefault(require("../../static/assets/matic2x.png"));
const mkr2x_png_1 = __importDefault(require("../../static/assets/mkr2x.png"));
const multihop_png_1 = __importDefault(require("../../static/assets/multihop.png"));
const pepe2x_png_1 = __importDefault(require("../../static/assets/pepe2x.png"));
const placeholder_coin_png_1 = __importDefault(require("../../static/assets/placeholder-coin.png"));
const shib2x_png_1 = __importDefault(require("../../static/assets/shib2x.png"));
const slp2x_png_1 = __importDefault(require("../../static/assets/slp2x.png"));
const sol2x_png_1 = __importDefault(require("../../static/assets/sol2x.png"));
const spice2x_png_1 = __importDefault(require("../../static/assets/spice2x.png"));
const srm2x_png_1 = __importDefault(require("../../static/assets/srm2x.png"));
const sushi2x_png_1 = __importDefault(require("../../static/assets/sushi2x.png"));
const tbtc2x_png_1 = __importDefault(require("../../static/assets/tbtc2x.png"));
const uni2x_png_1 = __importDefault(require("../../static/assets/uni2x.png"));
const usdc2x_png_1 = __importDefault(require("../../static/assets/usdc2x.png"));
const usdh2x_png_1 = __importDefault(require("../../static/assets/usdh2x.png"));
const usdt2x_png_1 = __importDefault(require("../../static/assets/usdt2x.png"));
const verse2x_png_1 = __importDefault(require("../../static/assets/verse2x.png"));
const verse_x2x_png_1 = __importDefault(require("../../static/assets/verse-x2x.png"));
const wbnb2x_png_1 = __importDefault(require("../../static/assets/wbnb2x.png"));
const wbtc2x_png_1 = __importDefault(require("../../static/assets/wbtc2x.png"));
const wojak2x_png_1 = __importDefault(require("../../static/assets/wojak2x.png"));
const wzano2x_png_1 = __importDefault(require("../../static/assets/wzano2x.png"));
const xai2x_png_1 = __importDefault(require("../../static/assets/xai2x.png"));
const xaut2x_png_1 = __importDefault(require("../../static/assets/xaut2x.png"));
const xlm2x_png_1 = __importDefault(require("../../static/assets/xlm2x.png"));
const xmr2x_png_1 = __importDefault(require("../../static/assets/xmr2x.png"));
const yfi2x_png_1 = __importDefault(require("../../static/assets/yfi2x.png"));
const zec2x_png_1 = __importDefault(require("../../static/assets/zec2x.png"));
const zrx2x_png_1 = __importDefault(require("../../static/assets/zrx2x.png"));
const coinList = {
    ape: { alt: 'ApeCoin', src: ape2x_png_1.default },
    avax: { alt: 'Avalanche', src: avax2x_png_1.default },
    band: { alt: 'Band Protocol', src: band2x_png_1.default },
    bch: { alt: 'Bitcoin Cash', src: bch2x_png_1.default },
    bnb: { alt: 'Binance Coin', src: bnb2x_png_1.default },
    btc: { alt: 'Bitcoin', src: btc2x_png_1.default },
    comp: { alt: 'Compound Token', src: comp2x_png_1.default },
    crv: { alt: 'Curve DAO Token', src: crv2x_png_1.default },
    dai: { alt: 'DAI', src: dai2x_png_1.default },
    dash: { alt: 'Dash', src: dash2x_png_1.default },
    doge: { alt: 'Dogecoin', src: doge2x_png_1.default },
    eth: { alt: 'Ethereum', src: eth2x_png_1.default },
    erc: { alt: 'ERC Token', src: erc2x_png_1.default },
    flex: { alt: 'Flex', src: flex2x_png_1.default },
    flexusd: { alt: 'FlexUSD', src: flexusd2x_png_1.default },
    floki: { alt: 'FLOKI', src: floki2x_png_1.default },
    ftt: { alt: 'FTX Token', src: ftt2x_png_1.default },
    goc: { alt: 'GoCrypto', src: goc2x_png_1.default },
    hapi: { alt: 'Hapi', src: hapi2x_png_1.default },
    lbtc: { alt: 'Bitcoin Lightning', src: lbtc2x_png_1.default },
    matic: { alt: 'Polygon', src: matic2x_png_1.default },
    ltc: { alt: 'Litecoin', src: ltc2x_png_1.default },
    mana: { alt: 'Decentraland', src: mana2x_png_1.default },
    mkr: { alt: 'Maker DAO Token', src: mkr2x_png_1.default },
    multihop: { alt: 'Multihop logo', src: multihop_png_1.default },
    pepe: { alt: 'Pepe', src: pepe2x_png_1.default },
    placeholder: { alt: 'Generic logo', src: placeholder_coin_png_1.default },
    shib: { alt: 'Shiba Inu', src: shib2x_png_1.default },
    slp: { alt: 'SLP Token', src: slp2x_png_1.default },
    sol: { alt: 'Solana', src: sol2x_png_1.default },
    spice: { alt: 'Spice', src: spice2x_png_1.default },
    srm: { alt: 'Serum', src: srm2x_png_1.default },
    sushi: { alt: 'Sushi', src: sushi2x_png_1.default },
    tbtc: { alt: 'tBTC v2', src: tbtc2x_png_1.default },
    uni: { alt: 'Uniswap Token', src: uni2x_png_1.default },
    usdc: { alt: 'USDC', src: usdc2x_png_1.default },
    usdh: { alt: 'HonestCoin', src: usdh2x_png_1.default },
    usdt: { alt: 'USDT', src: usdt2x_png_1.default },
    fxverse: { alt: 'VERSE', src: verse2x_png_1.default },
    verse: { alt: 'VERSE', src: verse2x_png_1.default },
    'verse-x': { alt: 'VERSE-X', src: verse_x2x_png_1.default },
    wbnb: { alt: 'Wrapped Binance Coin', src: wbnb2x_png_1.default },
    wbtc: { alt: 'Wrapped Bitcoin', src: wbtc2x_png_1.default },
    wojak: { alt: 'Wojak', src: wojak2x_png_1.default },
    wzano: { alt: 'Wrapped ZANO', src: wzano2x_png_1.default },
    xai: { alt: 'Sideshift', src: xai2x_png_1.default },
    xaut: { alt: 'Tether Gold', src: xaut2x_png_1.default },
    xlm: { alt: 'Stellar Lumens', src: xlm2x_png_1.default },
    xmr: { alt: 'Monero', src: xmr2x_png_1.default },
    yfi: { alt: 'yearn.finance', src: yfi2x_png_1.default },
    zec: { alt: 'Zcash', src: zec2x_png_1.default },
    zrx: { alt: '0x Token', src: zrx2x_png_1.default },
};
exports.default = coinList;
//# sourceMappingURL=coinList.js.map